import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

// The Questions macro is now the native-Relay handler only (the `confluence_questions_package_relay_
// migration` gate reached 100%, so the Apollo-vs-Relay selector was removed). The after-paint boundary
// loads `GlobalQuestionsListMacroHandler` directly; the chunk name is preserved so code-splitting
// for the editor macro is unchanged.
export const GlobalQuestionsListMacroHandler: LoadableType<{
	macroDefaultProps: ExtensionHandlerProps;
	macroParams: any;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalQuestionsListMacroHandler" */ '../src/GlobalQuestionsListMacroHandler.tsx'
			)
		).GlobalQuestionsListMacroHandler,
});
